import { render, staticRenderFns } from "./MkObjPopupTableInfo5.vue?vue&type=template&id=5056c02f&"
import script from "./MkObjPopupTableInfo5.vue?vue&type=script&lang=js&"
export * from "./MkObjPopupTableInfo5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports